module.exports = __webpack_public_path__ + "static/img/gou@2x.25c96ee0.png";